/**
 * 显示常规日志
 * @param keyWord 关键标题
 * @param content 日志内容
 * @param textStyle 日志样式, 同css属性和值
 */
export const showLog = (keyWord, content, textStyle) => {
  if (!content) {
    return;
  }
  // eslint-disable-next-line no-console
  console.log(`%c${keyWord || ""} ===>>>> ${typeof content === "string" ? content : JSON.stringify(content)}`, textStyle || "color:lightblue");
};
/**
 * 打印多个日志信息
 * @param type TLogLevel, 日志等级
 * @param args 接受多个参数
 */
export const showMultyLog = function (type) {
  const colorMapping = {
    succ: "color:green",
    error: "color:red",
    warn: "color:orange",
    info: "color:lightblue"
  };
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  if (args && args.length > 0) {
    // eslint-disable-next-line no-console
    console.log("%c 多参数日志: start", colorMapping[type]);
    args.forEach((param, index) => {
      // eslint-disable-next-line no-console
      console.log(`%c param${index + 1} ===>>>> ${typeof param === "string" ? param : JSON.stringify(param)}`, colorMapping[type]);
    });
    // eslint-disable-next-line no-console
    console.log("%c 多参数日志: end", colorMapping[type]);
  }
};
/**
 * 显示报错日志
 * @param content
 */
export const showErrorLog = (keyWord, content) => {
  showLog(keyWord, content, "color:red");
};
/**
 * 显示成功日志
 * @param content
 */
export const showSuccLog = function (keyWord) {
  for (var _len2 = arguments.length, content = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    content[_key2 - 1] = arguments[_key2];
  }
  showLog(keyWord, content, "color:green");
};
/**
 * 显示警告日志
 * @param content
 */
export const showWarnLog = (keyWord, content) => {
  showLog(keyWord, content, "color:orange");
};
/**
 * 判断是否debug模式
 * 打开方式: url包含debugMode=true
 * @returns boolean
 */
export const isDebug = () => {
  return /debugMode=true/.test(window.location.search);
};
// export const test = (keyWord: string) => {
//   console.log('string');
// };